import { isEmpty } from 'lodash-es'
import { getDataClass, load } from 'scrivito'

export const getDataItemsPromise = async (
  dataClassName: string,
  ids: string[],
) => {
  const dataClass = getDataClass(dataClassName)

  if (!dataClass) {
    return []
  }

  return load(() =>
    !isEmpty(ids) && dataClass
      ? dataClass
          .all()
          .transform({
            limit: ids.length,
            filters: {
              ids: ids.join(','),
            },
          })
          .take()
      : [],
  ).catch((error) => {
    console.log(error)
    return []
  })
}
